/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  User,
  UserEntity,
  UserUpdateDTO,
  UsersControllerV2ArchiveV2PathParameters,
  UsersControllerV2DeleteV2PathParameters,
  UsersControllerV2FindOneV2PathParameters,
  UsersControllerV2RestoreV2PathParameters,
  UsersControllerV2UpdateV2PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class UsersV2Service {
  private readonly http = inject(HttpClient);
  /**
   * @summary Get the authenticated user’s profile
   */

  getProfile<TData = User>(): Observable<TData> {
    return this.http.get<TData>(`/clients/v2/users/profile`);
  }
  /**
   * @summary Retrieve a specific user by ID
   */

  findOne<TData = UserEntity>({ userId }: UsersControllerV2FindOneV2PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v2/users/${userId}`);
  }
  /**
   * @summary Update user details
   */

  update<TData = User>({ userId }: UsersControllerV2UpdateV2PathParameters, userUpdateDTO: UserUpdateDTO): Observable<TData> {
    return this.http.patch<TData>(`/clients/v2/users/${userId}`, userUpdateDTO);
  }
  /**
   * @summary Delete a user permanently
   */

  delete<TData = void>({ userId }: UsersControllerV2DeleteV2PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/clients/v2/users/${userId}`);
  }
  /**
   * @summary Archive a user (soft delete)
   */

  archive<TData = User>({ userId }: UsersControllerV2ArchiveV2PathParameters): Observable<TData> {
    return this.http.post<TData>(`/clients/v2/users/${userId}/archive`, undefined);
  }
  /**
   * @summary Restore an archived user
   */

  restore<TData = User>({ userId }: UsersControllerV2RestoreV2PathParameters): Observable<TData> {
    return this.http.post<TData>(`/clients/v2/users/${userId}/restore`, undefined);
  }
}
